export default __webpack_public_path__ + "static/media/Yellow0005.ecd3931f.png";